export const closedStandalonePromotionStorageKey = 'closedStandalonePromotion';
